import { z } from "zod";

import { events as onboardingChecklistEvents } from "../feature/onboarding/analytics/events";
import { events as campaignEditEvents } from "../routes/_app.$account.advertising.$campaignId.edit/analytics/events";
import { events as advertisingEvents } from "../routes/_app.$account.advertising/analytics/events";
import { events as createAccountWizardEvents } from "../routes/_app.$account.create-account/analytics/events";
import { events as onboardingWizardEvents } from "../routes/onboard/analytics/events";
import { createAnalytics } from "./factory";

const allSchemas = {
  page_view: z.object({
    path: z.string(),
    search: z.string().optional(),
    referrer: z.string().optional(),
  }),
  ...advertisingEvents,
  ...campaignEditEvents,
  ...onboardingWizardEvents,
  ...createAccountWizardEvents,
  ...onboardingChecklistEvents,
};

export const { AnalyticsProvider, useAnalytics, useTrackOnce, PageViewTracker } = createAnalytics(allSchemas);
